import { render, staticRenderFns } from "./BlockFooter.vue?vue&type=template&id=0946f99e&"
import script from "./BlockFooter.vue?vue&type=script&lang=js&"
export * from "./BlockFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports